import { Typography } from '@euler/app/components/typography';
import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { BottomPanel } from '@euler/components/BottomPanel';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { BiPalette } from '@euler/model/bi/viz';
import { memo } from 'react';
import { ScrollView, useWindowDimensions, View } from 'react-native';
import { PaletteOption } from './PaletteOption';

const kPalettes = Object.values(BiPalette);
/** The panel's cap on every screen: `BottomPanel` allows 74% at the least. */
const kPanelShare = 0.74;

/**
 * The dashboard's palette: every card without its own colors takes it. A
 * pick saves at once and can be undone.
 */
export const PalettePanel = memo(
  ({
    visible,
    palette,
    busy,
    onPick,
    onClose,
  }: {
    visible: boolean;
    palette: BiPalette;
    busy: boolean;
    onPick: (palette: BiPalette) => void;
    onClose: () => void;
  }) => {
    const { rpx } = useResponsiveContext();
    const { height } = useWindowDimensions();
    return (
      <BottomPanel visible={visible} onClose={onClose} fitContent>
        <View style={{ paddingVertical: rpx(24), gap: rpx(12) }}>
          <View style={{ gap: rpx(4), paddingHorizontal: rpx(24) }}>
            <Typography.Text medium size={rpx(15)} color={aiColors.foreground}>
              看板配色
            </Typography.Text>
            <Typography.Text size={rpx(12)} color={aiColors.mutedForeground}>
              所有图表使用这套配色；单张图表设置了自己的配色或颜色时以图表为准。
            </Typography.Text>
          </View>
          <ScrollView
            // The room the panel leaves under its title: more palettes
            // than fit scroll instead of being cut off. Full width, the
            // inset inside, so the scrollbar runs at the panel's edge
            // rather than over the options.
            style={{ maxHeight: height * kPanelShare - rpx(120) }}
            contentContainerStyle={{
              gap: rpx(8),
              paddingHorizontal: rpx(24),
            }}
            accessibilityRole="radiogroup"
          >
            {kPalettes.map(option => (
              <PaletteOption
                key={option}
                palette={option}
                selected={option === palette}
                disabled={busy}
                onPress={() =>
                  option === palette ? onClose() : onPick(option)
                }
              />
            ))}
          </ScrollView>
        </View>
      </BottomPanel>
    );
  },
);
